import { show as showModal } from 'redux-modal'
import {exportPostData, handleExport} from "broker/util/helper";
import {queueExportDownload} from "broker/redux/account";
import {UNIVERSAL_EXPORT_LEAD_COUNT_LIMIT, UNIVERSAL_EXPORT_LEAD_TIME_LIMIT} from "common/constants";

export function getAuthEmail(state){
  return state.auth.user ? state.auth.user.username : null
}

export class GenericLeadsDownloader{
  constructor() {
    this.startedExport = null
    this.exportTimeout = false
    this.completedExport = true
    this.searchTimeout = false
  }

  asyncDownload({dispatch, email, searchTerm, activeFilters, exclude_duplicates, excludeOnHold, exportUrl,
                }) {
    dispatch(
      showModal(
        'DownloadModal',
        {
          email: email,
          exportTimeout: this.exportTimeout,
          onConfirm: (selectedEmail) => {
            const postData = exportPostData({
              activeFilters: activeFilters,
              searchTerm: searchTerm,
              excludeOnHold: excludeOnHold,
              excludeDuplicates: exclude_duplicates,
              emailAddress: selectedEmail,
              exportUrl: exportUrl
            })
            dispatch(queueExportDownload(postData))
          }
        }
      )
    )
  }

  syncDownload(params){
    const {activeFilters, searchTerm, excludeOnHold, exclude_duplicates, exportUrl} = params
    const startedExport = new Date().getTime()
    this.startedExport = startedExport
    this.completedExport = false
    handleExport({
      exportUrl: exportUrl,
      activeFilters: activeFilters,
      searchTerm: searchTerm,
      excludeOnHold: excludeOnHold,
      excludeDuplicates: exclude_duplicates,
      onload: () => {
        const now = new Date().getTime()
        const exportTimeout = (now - startedExport) > UNIVERSAL_EXPORT_LEAD_TIME_LIMIT
        this.completedExport = true
        this.exportTimeout = exportTimeout
        if (exportTimeout) {
          this.asyncDownload(params)
        }
      }
    })
  }

  shouldDownloadAsynchronously({account, auth, activeFilters, exportUrl}) {
    const enableAsyncDownloads = (account.feature_flags && account.feature_flags.enable_async_downloads) || auth.user.is_masquerade
    const moreThanLeadCountLimit = account.result_count > UNIVERSAL_EXPORT_LEAD_COUNT_LIMIT
    const { export_url_timeouts, export_url_timeout_order } = account
    const timeframeFilter = activeFilters.find((item) => item.filter_type === "timeframe")
    const timeframeIndex = export_url_timeout_order.indexOf(timeframeFilter.filter_value)
    const lastTimeoutIndex = export_url_timeout_order.indexOf(export_url_timeouts[exportUrl]);

    const lastExportFailed = (lastTimeoutIndex > -1 && (lastTimeoutIndex < timeframeIndex)) || !this.completedExport || this.exportTimeout || this.searchTimeout
    return enableAsyncDownloads && (lastExportFailed || moreThanLeadCountLimit)
  }

  initializeSearchState() {
    this.searchTimeout = false
    this.exportTimeout = false
  }

  searchTimedOut() {
    this.searchTimeout = true
  }

  download(params) {
    if (this.shouldDownloadAsynchronously(params)) {
      this.asyncDownload(params)
    } else {
      this.syncDownload(params)
    }
  }
}
